import React, { useState } from "react";
import {
  justinBradyDemo,
  lexDemoPodcasts,
  PodcastSelectionInterface,
  sanjayPodcasts,
} from "./PodcastSelectionInterface";
import { YouTubeLikeDemo } from "./YouTubeLikeDemo";

// a dictionary mapping strings to PodcastSelectionInterface[]:
const passwordToPodcastsMapping: Map<string, PodcastSelectionInterface[]> =
  (() => {
    const map = new Map<string, PodcastSelectionInterface[]>();

    map.set("demo", lexDemoPodcasts());
    map.set("sanjay@unlockvp", sanjayPodcasts());
    map.set("justinbrady", justinBradyDemo());

    return map;
  })();

function PasswordSplashScreenItself(props: {
  setDisplayedPodcasts: (selectedPodcasts: PodcastSelectionInterface[]) => void;
}): JSX.Element {
  const [passwordLikeText, setPasswordLikeText] = useState("");
  const { setDisplayedPodcasts } = props;

  const onEnter = (
    _passwordLikeText: string,
    _setDisplayedPodcasts: (
      selectedPodcasts: PodcastSelectionInterface[]
    ) => void
  ) => {
    const podcasts = passwordToPodcastsMapping.get(
      _passwordLikeText.toLowerCase()
    );
    if (podcasts && podcasts.length > 0) {
      _setDisplayedPodcasts(podcasts);
    }
  };

  return (
    <div className="password-splash-itself">
      <div>
        <input
          type="text"
          value={passwordLikeText}
          onChange={(event) => setPasswordLikeText(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              onEnter(passwordLikeText, setDisplayedPodcasts);
            }
          }}
        />
      </div>
      <div>
        <button
          type="button"
          onClick={() => onEnter(passwordLikeText, setDisplayedPodcasts)}
        >
          Enter Demo
        </button>
      </div>
    </div>
  );
}

export function FakeablePasswordSplashScreen(): JSX.Element {
  // present a splash screen with a text field and a "Enter" button.
  // When "Enter" is pressed, display a different JSX.Element depending on the text entered.

  const [displayedPodcasts, setDisplayedPodcasts] = useState<
    PodcastSelectionInterface[]
  >([]);

  return (
    <div className="password-splash-screen">
      {displayedPodcasts.length > 0 && (
        <YouTubeLikeDemo allPodcasts={displayedPodcasts} />
      )}
      {displayedPodcasts.length === 0 && (
        <PasswordSplashScreenItself
          setDisplayedPodcasts={setDisplayedPodcasts}
        />
      )}
    </div>
  );
}
